var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"row\"><div ng-if=\"$ctrl.headlines.length > 0\" id=\"wide-col\" class=\"col-xs-12\"><h1 class=\"heading main\" itemprop=\"headline\">{{$ctrl.headlines[0].join(' - ')}}</h1></div></div>";
var id1="auto-query-headlines.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;